import { render, staticRenderFns } from "./layActiveInfo.vue?vue&type=template&id=a0c99d82&scoped=true"
import script from "./layActiveInfo.vue?vue&type=script&lang=js"
export * from "./layActiveInfo.vue?vue&type=script&lang=js"
import style0 from "./layActiveInfo.vue?vue&type=style&index=0&id=a0c99d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c99d82",
  null
  
)

export default component.exports